import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import { ResponsiveDialog, useSettings } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import DemsLogsColumn from './DemsLogsColumn';
import { openDialog, closeDialog } from 'app/store/fuse/dialogSlice';
import type { MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';

interface DemsLogListDialogProps {
	model: any;
	module: string;
	filters?: MiddlewhereFilter[];
}

export function showDemsLogListDialog(props: DemsLogListDialogProps) {
	return openDialog({
		children: <DemsLogListDialog {...props} />,
		maxWidth: 'sm',
		fullWidth: true
	});
}

function DemsLogListDialog(props: DemsLogListDialogProps) {
	const { t, settings } = useSettings();
	const dispatch = useDispatch();

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(state => !state);

	const handleClose = () => {
		dispatch(closeDialog());
	};

	const columns = DemsLogsColumn({ settings, t, updateRefresh });

	return (
		<ResponsiveDialog
			open={true}
			onClose={handleClose}
			classes={{ content: 'flex flex-col p-0' }}
			maxWidth="lg"
			disablePadding
			dividers
			title={t('LOGS')}
			content={
				<ViewTable
					className="border-none"
					module={props.module}
					defaultFilters={props.model.dwid_defaultfilters}
					filters={props.filters}
					refresh={refresh}
					updateRefresh={updateRefresh}
					columns={columns}
					showFilters={false}
				/>
			}
			actions={<Button onClick={handleClose}>{t('DIALOG_ACTION_CLOSE')}</Button>}
		/>
	);
}

export default React.memo(DemsLogListDialog);
